module.exports = __webpack_public_path__ + "static/media/universitylimerick.67103b93.png";